// Pure date helpers for the wheel picker — unit-testable without a DOM.

export function daysInMonth(year: number, month1: number): number {
  // month1 is 1-based. Day 0 of next month = last day of this month.
  return new Date(year, month1, 0).getDate();
}

export function clampDay(year: number, month1: number, day: number): number {
  return Math.min(Math.max(1, day), daysInMonth(year, month1));
}

export function toISO(year: number, month1: number, day: number): string {
  const mm = String(month1).padStart(2, "0");
  const dd = String(clampDay(year, month1, day)).padStart(2, "0");
  return `${year}-${mm}-${dd}`;
}

/** Parse YYYY-MM-DD → parts, or return a sensible default (fallbackYear-06-15). */
export function parseISO(iso: string, fallbackYear: number): { year: number; month1: number; day: number } {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return { year: fallbackYear, month1: 6, day: 15 };
  const year = Number(m[1]), month1 = Number(m[2]), day = Number(m[3]);
  return { year, month1: clampMonth(month1), day: clampDay(year, clampMonth(month1), day) };
}

export function clampMonth(month1: number): number {
  return Math.min(Math.max(1, month1), 12);
}

/** Localized short month names (Jan…Dec in the given locale) via Intl. */
export function monthNames(locale: string): string[] {
  const fmt = new Intl.DateTimeFormat(locale, { month: "short" });
  return Array.from({ length: 12 }, (_, i) => fmt.format(new Date(2020, i, 1)));
}
